var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResultIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_11870",
    "data-name": "Group 11870",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16879",
    "data-name": "Rectangle 16879",
    width: 22,
    height: 22,
    fill: "#b0b6d2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11869",
    "data-name": "Group 11869",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37787",
    "data-name": "Path 37787",
    d: "M11.027,0q3.712,0,7.423,0A3.433,3.433,0,0,1,22,3.562q0,4.141,0,8.283a.863.863,0,0,1-.785.951.847.847,0,0,1-.931-.872c-.01-.607,0-1.214,0-1.822q0-3.248,0-6.5A1.732,1.732,0,0,0,18.4,1.721q-7.406,0-14.812,0A1.728,1.728,0,0,0,1.722,3.583q0,7.423,0,14.847a1.725,1.725,0,0,0,1.845,1.849q4.3,0,8.592,0a.873.873,0,0,1,.979.756.849.849,0,0,1-.874.961c-.894.008-1.787,0-2.681,0q-3.025,0-6.049,0A3.433,3.433,0,0,1,0,18.457Q0,11,0,3.541A3.432,3.432,0,0,1,3.535,0q3.746,0,7.492,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37788",
    "data-name": "Path 37788",
    d: "M102.461,105.3a3.863,3.863,0,0,1,6.786-2.517,3.813,3.813,0,0,1,.476,4.356.386.386,0,0,0,.083.575c.357.321.685.674,1.024,1.015.471.473.524.968.147,1.352s-.887.34-1.376-.146c-.349-.347-.706-.687-1.04-1.048a.4.4,0,0,0-.555-.1,3.86,3.86,0,0,1-5.544-3.487m3.857-2.125a2.139,2.139,0,1,0,2.155,2.12,2.134,2.134,0,0,0-2.155-2.12",
    transform: "translate(-89.226 -88.347)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37789",
    "data-name": "Path 37789",
    d: "M30.269,36.611q1.821,0,3.642,0a.829.829,0,0,1,.789.453.815.815,0,0,1-.045.879.939.939,0,0,1-.866.389q-2.319,0-4.638,0c-.836,0-1.672.009-2.508,0a.863.863,0,0,1-.857-1.235.878.878,0,0,1,.876-.485c1.2.006,2.4,0,3.608,0",
    transform: "translate(-22.373 -31.879)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37790",
    "data-name": "Path 37790",
    d: "M30.266,76.525c1.214,0,2.428-.007,3.642,0a.848.848,0,0,1,.83,1.219.878.878,0,0,1-.87.5q-1.117,0-2.233,0H26.893c-.1,0-.207,0-.309,0a.867.867,0,0,1-.865-.882.847.847,0,0,1,.9-.832c1.214-.008,2.428,0,3.642,0",
    transform: "translate(-22.397 -66.638)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37791",
    "data-name": "Path 37791",
    d: "M51.125,120.41c-.206,0-.413.01-.618,0a.856.856,0,0,1-.819-.853.847.847,0,0,1,.812-.857c.434-.018.871-.02,1.3,0a.855.855,0,0,1,.007,1.707c-.228.017-.458,0-.687,0h0",
    transform: "translate(-43.27 -103.354)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultIcon);
export default __webpack_public_path__ + "static/media/resultIcon.8997de849e2504490a8efff4feff3d92.svg";
export { ForwardRef as ReactComponent };